import { render, staticRenderFns } from "./NewOrderProduct.vue?vue&type=template&id=5ea28e72&scoped=true"
import script from "./NewOrderProduct.vue?vue&type=script&lang=js"
export * from "./NewOrderProduct.vue?vue&type=script&lang=js"
import style0 from "./NewOrderProduct.vue?vue&type=style&index=0&id=5ea28e72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea28e72",
  null
  
)

export default component.exports